// extracted by mini-css-extract-plugin
export default {"chatLoaderContainer":"chatloader_chatLoaderContainer__gbVd2","spinner":"chatloader_spinner__wHWCQ"};